export enum PocketsReportType {
  Variant = 0,
  Article = 1,
  Size = 2,
  Categories = 3,
}
